module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Text 文本相关")]), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("1. text-ellipsis 文本超出容器显示省略号")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "fg-dark"
  }, [_vm._v("加上text-ellipsis类后")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<div style=\"width:400px;\">\n  <p class=\"text-ellipsis\">\n    ISO-8859-1 的较低部分（从 1 到 127 之间的代码）是最初的 ASCII 字符集\n    （0-9 的数字，大写和小写英文字母表，以及一些特殊字符）\n  </p>\n</div>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bottom"
  }, [_vm._v("2. line-clamp* 超出多行显示省略号(该class只对webkit内核的浏览器有效)")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "fg-dark"
  }, [_vm._v("line-clamp2")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "fg-dark"
  }, [_vm._v("line-clamp3")]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fg-gray"
  }, [_c('span', {
    staticClass: "fg-dark"
  }, [_vm._v("原文:")]), _vm._v("\n      ISO-8859-1 的较低部分（从 1 到 127 之间的代码）是最初的 ASCII 字符集（0-9 的数字，大写和小写英文字母表，以及一些特殊字符）\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box padding5",
    staticStyle: {
      "width": "400px"
    }
  }, [_c('p', {
    staticClass: "text-ellipsis"
  }, [_vm._v("\n          ISO-8859-1 的较低部分（从 1 到 127 之间的代码）是最初的 ASCII 字符集（0-9 的数字，大写和小写英文字母表，以及一些特殊字符）\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "fg-gray"
  }, [_c('span', {
    staticClass: "fg-dark"
  }, [_vm._v("原文:")]), _vm._v("\n      无论是窗外的丝丝凉意，还是独行路上的阵阵微风，有种味道会让你想起那些欢声笑语，那些温暖涟漪，原来人生最怀念不过，一起吃着火锅听着歌\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box padding5",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('p', {
    staticClass: "line-clamp2"
  }, [_vm._v("\n        无论是窗外的丝丝凉意，还是独行路上的阵阵微风，有种味道会让你想起那些欢声笑语，那些温暖涟漪，原来人生最怀念不过，一起吃着火锅听着歌\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashed-box padding5",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('p', {
    staticClass: "line-clamp3"
  }, [_vm._v("\n        无论是窗外的丝丝凉意，还是独行路上的阵阵微风，有种味道会让你想起那些欢声笑语，那些温暖涟漪，原来人生最怀念不过，一起吃着火锅听着歌\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c08c2c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helper/text.vue
// module id = 402
// module chunks = 1